module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-15.d679af91.jpeg";